import {
  AfterContentChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { SortModel } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { ComponentService } from 'src/app/service/component.service';
import { DealerPriceService } from 'src/app/service/dealer-price/dealer-price.service';
import { StorageService } from 'src/app/service/storage/storage.service';

@Component({
  selector: 'app-product-sorting',
  templateUrl: './product-sorting.component.html',
  styleUrls: ['./product-sorting.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProductSortingComponent implements OnInit, OnDestroy, AfterContentChecked {
  @Input()
  sortOptions: SortModel[];
  @Input()
  selectedOption: string;
  @Input()
  placeholder: string;
  @Input()
  sortLabels: { [code: string]: string };

  @Input() sidenav: any;

  @Output()
  sortListEvent: EventEmitter<string>;

  showSrp = false;
  basepriceHidden = false;
  basePriceAsc = 'basePrice-asc';
  basePriceDes = 'basePrice-desc';
  srpSubscription$: Subscription;
  basepriceBehaviorConfig$: Subscription;

  constructor(
    private componentService: ComponentService,
    private cdr: ChangeDetectorRef,
    private storageService: StorageService,
    private dealerPriceService: DealerPriceService
  ) {
    this.sortListEvent = new EventEmitter<string>();
  }

  sortList(sortCode: string): void {
    this.sortListEvent.emit(sortCode);
  }

  ngOnInit() {
    this.getInitSrpToggleValue();

    this.srpSubscription$ = this.componentService.srpToggle$.subscribe((checked) => {
      this.showSrp = checked;
      this.cdr.detectChanges();
    });

    this.basepriceBehaviorConfig$ = this.dealerPriceService.getBasepriceBehavior$().subscribe((hideBaseprice: any) => {
      if (hideBaseprice === 'true') {
        this.basepriceHidden = true;
      } else {
        this.basepriceHidden = false;
      }
      this.cdr.detectChanges();
    });
  }

  getInitSrpToggleValue() {
    this.showSrp = this.storageService.getLocalStorageItem('showSrp') === 'true';
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.srpSubscription$?.unsubscribe();
    this.basepriceBehaviorConfig$?.unsubscribe();
  }
}
